<template>
  <div class="footer site-footer">
    <div class="footer-content">
      <!-- <div style="height:30px;"></div> -->

      <div class="footer-column">

        <h5>Crypto Clothing</h5>

        <div style="height:20px;"></div>

        <!-- <router-link to="/about" class="hover-footer">About</router-link>
        <br> -->
        <router-link to="/terms-and-conditions" class="hover-footer">Terms</router-link>
        <br>
        <router-link to="/privacy-policy" class="hover-footer">Privacy</router-link>
        <br>
        <router-link to="/shipping" class="hover-footer">Shipping & Returns</router-link>
        <br>
        <router-link to="/contacts" class="hover-footer">Contacts</router-link>

        <div style="height:25px;"></div>

        <a href="https://cryptologos.cc" target="_blank" class="hover-footer">Crypto Logos</a>
        <br>
        <a href="https://coinwink.com" target="_blank" class="hover-footer">Bitcoin Alert App</a>
        <br>
        <a href="https://multiavatar.com" target="_blank" class="hover-footer">Avatar Generator</a>
        <br>
        <a href="https://8020.in" target="_blank" class="hover-footer">80/20 Rule</a>


      </div>


      <div class="footer-column">
        
        <h5>Categories</h5>

        <div style="height:20px;"></div>

        <!-- <br> -->
        <router-link to="/crypto-t-shirts">T-Shirts</router-link>
        <br>
        <router-link to="/crypto-longsleeve-t-shirts">Long Sleeve T-Shirts</router-link>        
        <br>
        <router-link to="/crypto-hoodies">Hoodies</router-link>
        <br>
        <router-link to="/crypto-dresses">Dresses</router-link>
        <br>
        <router-link to="/crypto-sweatshirts">Sweatshirts</router-link>        
        <br>
        <router-link to="/crypto-mugs">Mugs</router-link>
        <br>
        <router-link to="/crypto-stickers">Stickers</router-link>
        <br>
        <router-link to="/crypto-laptop-cases">Laptop Cases</router-link>        
        <br>
        <router-link to="/crypto-backpacks">Backpacks</router-link>
        <br>
        <router-link to="/crypto-face-masks">Neck Gaiters</router-link>
        <!-- <br>
        <router-link to="/crypto-face-masks">AI x ART</router-link> -->
        <!-- <br>
        <router-link to="/crypto-fashion">Crypto Fashion</router-link> -->
        


        <!-- 
        <a href="https://cryptoclothing.cc/crypto-polo-shirts">Hats</a>
        <br> 
        <a href="https://cryptoclothing.cc/crypto-polo-shirts">Polo Shirts</a> 
        -->

      </div>


      <div class="footer-column">
        
        <h5>Contacts</h5>

        <div style="height:20px;"></div>

        &#105;n&#x66;o&#x40;c&#x72;y&#x70;&#116;&#x6f;&#99;&#x6c;&#111;&#x74;&#104;i&#110;g&#x2e;c&#x63;
        


        <div style="height:42px;"></div>

        <h5>Payment methods</h5>


        <!-- <div style="font-size:13px;color:#999;margin-top:-2px;">Crypto Clothing 2020</div> -->

        <div style="font-size:13px;color:#999;margin-top:-2px;">Stripe & Coinbase</div>

        <div style="height:20px;"></div>

        <!-- <img src="/img/payment-methods.svg?v=003" width="213"> -->

        <div style="width:213px;">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1366 357.41"><g id="Layer_2" data-name="Layer 2"><g id="Payment_Methods" data-name="Payment Methods"><g id="Litecoin"><title>Litecoin</title><circle cx="601.94" cy="276.57" r="60.52" style="fill:#fff"/><path d="M601.94,208.7a67.87,67.87,0,1,0,67.87,67.87h0v-.2a67.68,67.68,0,0,0-67.47-67.67Zm1.15,70.17L596,302.7h37.86a1.91,1.91,0,0,1,1.91,1.84v.63l-3.29,11.33a2.45,2.45,0,0,1-2.36,1.81H572.2l9.7-33-10.85,3.29,2.46-7.56,10.85-3.29L598,231.38a2.48,2.48,0,0,1,2.39-1.81h14.77a1.91,1.91,0,0,1,1.9,1.84V232l-11.5,39.11,10.85-3.29-2.3,7.89-11,3.12Z" style="fill:#345d9d"/></g><g id="Ethereum"><title>Ethereum</title><polygon points="856.85 195.72 855.76 199.41 855.76 306.32 856.85 307.4 906.47 278.07 856.85 195.72" style="fill:#343434"/><polygon points="856.85 195.72 807.22 278.07 856.85 307.4 856.85 255.51 856.85 195.72" style="fill:#8c8c8c"/><polygon points="856.85 316.8 856.23 317.55 856.23 355.63 856.85 357.42 906.5 287.48 856.85 316.8" style="fill:#3c3c3b"/><polygon points="856.85 357.42 856.85 316.8 807.22 287.48 856.85 357.42" style="fill:#8c8c8c"/><polygon points="856.85 307.4 906.47 278.07 856.85 255.51 856.85 307.4" style="fill:#141414"/><polygon points="807.22 278.07 856.85 307.4 856.85 255.51 807.22 278.07" style="fill:#393939"/></g><g id="American_Express" data-name="American Express"><title>American Express</title><path d="M668.7,0H535.27a9.56,9.56,0,0,0-9.53,9.53V95.3a9.56,9.56,0,0,0,9.53,9.52H668.7a9.53,9.53,0,0,0,9.44-9.53V9.53A9.55,9.55,0,0,0,668.62,0Z" style="fill:#4ca0d8"/><path d="M554,51.68h8.09l-4-9.55ZM668.64,33.36H647.76l-4.7,5.1-4.56-5.1h-45L589.65,42l-3.94-8.61h-18v3.91l-2-3.91H550.33L535.27,66.69h18l2.24-5.4h5.1l2.24,5.4h19.84V62.61l1.78,4.08h10.25l1.78-4.16v4.16H637.8l5-5.18,4.69,5.18H668.7l-15.11-16.6,15.06-16.73h0ZM606.57,62h-5.8V43.26L592.27,62h-5.21L578.5,43.26V62h-12l-2.27-5.4H552L549.71,62H543.2l10.61-24h8.8l10,22.61V38h9.61l7.72,16.19L597.18,38h9.55l-.16,24Zm51,0H650l-7.21-7.77-7.55,7.91H611.94V38h23.7l7.26,7.82L650.37,38h7.26l-11,12L657.6,62ZM617.77,43.1v4.37H630.7v4.86H617.77v4.78h14.49l6.72-7-6.45-7Z" style="fill:#fff"/></g><g id="Mastercard"><title>Mastercard</title><path d="M404.94,0H271.53A9.56,9.56,0,0,0,262,9.55V95.3a9.52,9.52,0,0,0,9.52,9.52H404.94a9.52,9.52,0,0,0,9.52-9.52V9.55A9.56,9.56,0,0,0,404.94,0Z" style="fill:#e6e6e5"/><path d="M338.22,29.12a33.36,33.36,0,1,0-.57,47.18l.57-.57a33.31,33.31,0,0,1,0-46.61Z" style="fill:#e64d3c"/><path d="M362.1,19.14H362a33.19,33.19,0,0,0-23.77,10,33.35,33.35,0,0,1,0,46.61,33.32,33.32,0,1,0,23.84-56.64h0Z" style="fill:#f7a01d"/><path d="M338.22,29.12a33.31,33.31,0,0,0,0,46.61A33.35,33.35,0,0,0,338.22,29.12Z" style="fill:#f26122"/></g><g id="Visa"><title>Visa</title><path d="M0,85.77v9.52a9.53,9.53,0,0,0,9.53,9.53h133.4a9.53,9.53,0,0,0,9.53-9.53V85.77Z" style="fill:#f7a01d"/><polygon points="0 19.05 152.46 19.05 152.46 85.77 0 85.77 0 19.05" style="fill:#e6e6e5"/><path d="M142.93,0H9.53A9.56,9.56,0,0,0,0,9.53v9.61H152.46V9.53A9.56,9.56,0,0,0,142.93,0Z" style="fill:#5165a1"/><path d="M65.8,33.3,60.05,71.41h9.18L75,33.3ZM93.46,48.82c-3.21-1.67-5.15-2.7-5.15-4.53S90,41.1,93.7,41.1a14.92,14.92,0,0,1,6.83,1.41l.84.4,1.24-8.09a21.75,21.75,0,0,0-8.1-1.57c-9.06,0-15.46,5-15.49,12.23,0,5.39,4.56,8.23,8.1,10s4.75,3,4.75,4.62c0,2.45-2.86,3.61-5.4,3.61a17.52,17.52,0,0,1-9-1.86l-1.21-.59L75,69.52a27.09,27.09,0,0,0,10.23,2c9.63,0,15.9-4.94,16-12.58,0-4.21-2.43-7.42-7.72-10.07Zm32.63-15.38h-7.18a4.5,4.5,0,0,0-4.8,3.05L100.48,71.41h9.63l2.7-7.56h10.8L125,71.44h8.5ZM115.51,56.22c.19,0,3.7-12.34,3.7-12.34l2.7,12.34ZM52.39,33.3l-9,25.88-1-5A28.13,28.13,0,0,0,29.74,38.75L38,71.49h9.69l14.44-38-9.71-.14Z" style="fill:#5165a1;fill-rule:evenodd"/><path d="M37.43,36.27a3.72,3.72,0,0,0-4-3H19.19l-.14.73A29.66,29.66,0,0,1,40.64,52.41L37.43,36.27Z" style="fill:#f7a01d"/></g><g id="USD_Coin" data-name="USD Coin"><title>USD Coin</title><path d="M1298.13,344.44a67.87,67.87,0,1,0-67.87-67.87A67.71,67.71,0,0,0,1298.13,344.44Z" style="fill:#2775ca"/><path d="M1316.8,287.32c0-9.9-5.94-13.29-17.82-14.71-8.48-1.13-10.18-3.39-10.18-7.35s2.83-6.51,8.48-6.51c5.09,0,7.92,1.7,9.33,5.94a2.15,2.15,0,0,0,2,1.42h4.53a1.94,1.94,0,0,0,2-2v-.28a14.13,14.13,0,0,0-12.73-11.6v-6.79c0-1.13-.85-2-2.26-2.26h-4.24c-1.13,0-2,.85-2.26,2.26V252c-8.49,1.13-13.86,6.78-13.86,13.85,0,9.34,5.65,13,17.53,14.43,7.92,1.41,10.47,3.11,10.47,7.63s-4,7.64-9.34,7.64c-7.35,0-9.9-3.11-10.74-7.36a2.06,2.06,0,0,0-2-1.69h-4.81a1.93,1.93,0,0,0-2,2v.28c1.13,7.07,5.66,12.16,15,13.57v6.79c0,1.13.85,2,2.26,2.26h4.24c1.14,0,2-.84,2.27-2.26V302.3c8.48-1.41,14.13-7.35,14.13-15h0Z" style="fill:#fff"/><path d="M1283.71,317a42.32,42.32,0,0,1,0-79.47,2.83,2.83,0,0,0,1.7-2.82v-4a2.15,2.15,0,0,0-1.7-2.26,1.71,1.71,0,0,0-1.13.28,50.89,50.89,0,0,0,0,97,1.72,1.72,0,0,0,2.54-1.14c.29-.28.29-.56.29-1.13v-4a3.78,3.78,0,0,0-1.7-2.54Zm30-88.23a1.71,1.71,0,0,0-2.54,1.13c-.28.28-.28.57-.28,1.13v4a3.75,3.75,0,0,0,1.69,2.83,42.31,42.31,0,0,1,0,79.46,2.85,2.85,0,0,0-1.69,2.83v4a2.14,2.14,0,0,0,1.69,2.26,1.7,1.7,0,0,0,1.13-.28,51.11,51.11,0,0,0,0-97.28Z" style="fill:#fff"/></g><g id="Bitcoin_Cash" data-name="Bitcoin Cash"><title>Bitcoin Cash</title><g id="wordmark-bitcoincash-dark.min"><g id="Rectangle"><polygon id="path0_fill" data-name="path0 fill" points="257.08 225.82 419.39 225.82 419.39 327.27 257.08 327.27 257.08 225.82" style="fill:#fff"/></g><g id="Vector"><path id="path1_fill" data-name="path1 fill" d="M257.08,225.82h46.36A61.55,61.55,0,0,0,284.27,248a62.52,62.52,0,0,0,0,57.18,61.5,61.5,0,0,0,19.17,22.14H257.08V225.82Zm81.13,0a49.64,49.64,0,0,0-35.32,14.83,51.33,51.33,0,0,0,0,71.73,49.46,49.46,0,0,0,70.63,0,51.3,51.3,0,0,0,0-71.73,49.54,49.54,0,0,0-35.31-14.83Zm81.18,0H373A61.65,61.65,0,0,1,392.2,248a62.64,62.64,0,0,1,0,57.24A61.65,61.65,0,0,1,373,327.32h46.36Z" style="fill:#f7931a"/></g><g id="Vector-2" data-name="Vector"><path id="path2_fill" data-name="path2 fill" d="M360.28,261.67c-2.25-6.43-8.4-7.19-15.6-6l-2.25-9.12-5.49,1.37,2.2,8.9-4.34,1.16-2.2-9-5.49,1.38,2.25,9.11c-1.15.33-2.36.66-3.46.94v-.06l-7.58,1.93,1.48,5.93s4-1.1,4-1a2.89,2.89,0,0,1,3.73,1.65l2.58,10.43a2.71,2.71,0,0,1,.61-.11l-.61.17L333.64,294a2,2,0,0,1-1.59,2.36c.11.06-4,1-4,1l.55,6.92,7.14-1.81c1.32-.33,2.64-.66,3.9-.94l2.25,9.23,5.5-1.37-2.26-9.17c1.54-.33,3-.72,4.4-1.05l2.25,9.12,5.49-1.37L355,297.65c9.06-2.86,14.94-6.87,13.57-15.88-1.1-7.25-5.17-9.55-10.71-9.5,2.8-2.47,4.06-5.87,2.41-10.6Zm-2.8,21.7c1.71,6.92-10.16,9.06-13.84,10l-3-12.24c3.74-.88,15.11-4.89,16.86,2.25Zm-6.75-16.59c1.54,6.26-8.35,8-11.43,8.79l-2.74-11.1c3.07-.82,12.52-4.28,14.17,2.31Z" style="fill:#fff"/></g></g></g><g id="Google_Pay" data-name="Google Pay"><title>Google Pay</title><g id="Pay"><path id="Shape" d="M851.25,51.47V76h-7.66V15.47h20.32A18,18,0,0,1,877,20.73a17.65,17.65,0,0,1,.85,24.71l-.85.87a18.29,18.29,0,0,1-13.13,5.16Zm0-28.57V44H864.1a10,10,0,0,0,7.56-3.14,10.75,10.75,0,0,0-.24-15,10.35,10.35,0,0,0-7.32-3Z" style="fill:#b3b3b3"/><path d="M900.21,33.23c5.66,0,10.13,1.54,13.42,4.58s4.9,7.29,4.9,12.65V76H911.2V70.24h-.33c-3.19,4.73-7.38,7.1-12.66,7.1a16.24,16.24,0,0,1-11.27-4.06,12.85,12.85,0,0,1-4.52-10.13,12.4,12.4,0,0,1,4.8-10.23c3.19-2.56,7.47-3.81,12.8-3.81a22.82,22.82,0,0,1,11.23,2.51V49.83a9.11,9.11,0,0,0-3.14-6.9,11,11,0,0,0-7.38-2.85,11.6,11.6,0,0,0-10.13,5.5l-6.76-4.29q5.43-8,16.37-8.06Zm-9.9,30.07a6.29,6.29,0,0,0,2.52,5.06,9.29,9.29,0,0,0,5.95,2,12.05,12.05,0,0,0,8.61-3.62,11.47,11.47,0,0,0,3.81-8.54c-2.38-1.93-5.71-2.9-10-2.85a13.12,13.12,0,0,0-7.81,2.27,6.8,6.8,0,0,0-3.09,5.65Z" style="fill:#b3b3b3"/><polygon id="Path" points="960.59 34.58 934.99 94.18 927.09 94.18 936.61 73.33 919.81 34.58 928.14 34.58 940.27 64.31 940.41 64.31 952.26 34.58 960.59 34.58" style="fill:#b3b3b3;fill-rule:evenodd"/></g><g id="Super-G"><path d="M820.28,46.16a43.51,43.51,0,0,0-.57-7H787.4V52.48h18.51a16.07,16.07,0,0,1-6.85,10.57v8.69h11c6.47-6,10.18-15,10.18-25.58Z" style="fill:#4285f4;fill-rule:evenodd"/><path d="M787.4,80.14c9.23,0,17-3.09,22.7-8.4l-11-8.69a20.26,20.26,0,0,1-11.66,3.33,20.54,20.54,0,0,1-19.22-14.33H756.81v9A34.17,34.17,0,0,0,787.4,80.14Z" style="fill:#34a853;fill-rule:evenodd"/><path d="M768.18,52.05a21.21,21.21,0,0,1,0-13.32V29.8H756.81a34.91,34.91,0,0,0,0,31.18l11.37-8.93Z" style="fill:#fbbc04;fill-rule:evenodd"/><path d="M787.4,24.4a18.26,18.26,0,0,1,13.13,5.21l9.8-9.94a32.82,32.82,0,0,0-22.93-9A34.2,34.2,0,0,0,756.81,29.8l11.37,9c2.71-8.25,10.28-14.38,19.22-14.38Z" style="fill:#ea4335;fill-rule:evenodd"/></g></g><g id="Bitcoin"><title>Bitcoin</title><path d="M142.06,293a67.85,67.85,0,1,1-49.42-82.26A67.85,67.85,0,0,1,142.06,293Z" style="fill:#f7931a"/><path d="M106.16,266.9c1.35-9-5.53-13.89-14.93-17.12l3-12.24-7.45-1.85-3,11.91c-2-.49-4-.95-6-1.41l3-12-7.45-1.85-3,12.23c-1.62-.37-3.21-.74-4.75-1.12v0l-10.27-2.56-2,7.95s5.53,1.27,5.41,1.34c3,.76,3.56,2.75,3.47,4.34L58.8,268.42a7.4,7.4,0,0,1,.77.25l-.79-.19L53.91,288a2.7,2.7,0,0,1-3.41,1.77c.08.11-5.41-1.35-5.41-1.35L41.39,297l9.69,2.41c1.81.45,3.57.93,5.31,1.37l-3.08,12.38L60.75,315l3-12.24q3,.82,5.94,1.54l-3,12.19,7.45,1.85L77.23,306c12.69,2.41,22.24,1.44,26.26-10.05,3.24-9.25-.16-14.58-6.84-18.06,4.87-1.13,8.53-4.33,9.51-10.94Zm-17,23.86c-2.3,9.25-17.87,4.25-22.92,3l4.09-16.4C75.36,278.62,91.55,281.12,89.14,290.76Zm2.3-24c-2.1,8.41-15.06,4.14-19.26,3.09L75.89,255c4.2,1.05,17.74,3,15.55,11.78Z" style="fill:#fff"/></g><g id="Dai"><title>Dai</title><path d="M1087.16,208.7a67.87,67.87,0,1,1-67.87,67.87A67.87,67.87,0,0,1,1087.16,208.7Z" style="fill:#f5ac37"/><path d="M1089.67,281.36h25.79c.55,0,.81,0,.85-.72a49.49,49.49,0,0,0,0-7.89c0-.51-.26-.72-.81-.72h-51.33c-.63,0-.8.21-.8.81v7.55c0,1,0,1,1,1Zm23.76-18.15a.88.88,0,0,0,0-.6,17.29,17.29,0,0,0-1.54-2.67,21.69,21.69,0,0,0-3.13-3.94,10.13,10.13,0,0,0-2-1.91,30.33,30.33,0,0,0-12.72-6.45,31.84,31.84,0,0,0-7.21-.77h-22.78c-.64,0-.72.26-.72.81v15.06c0,.63,0,.8.8.8h48.95s.43-.08.51-.33Zm0,27a9.84,9.84,0,0,0-2.17,0h-47c-.64,0-.85,0-.85.85v14.72c0,.68,0,.85.85.85h21.71a10.76,10.76,0,0,0,3.1-.21,32.42,32.42,0,0,0,9.21-2,16.36,16.36,0,0,0,3.09-1.44h.3A27.55,27.55,0,0,0,1113.46,291s.3-.64,0-.82Zm-58.59,24.06V290.78c0-.55,0-.64-.68-.64H1045c-.51,0-.72,0-.72-.68V281.4h9.84c.55,0,.76,0,.76-.72v-8c0-.51,0-.64-.68-.64H1045c-.51,0-.72,0-.72-.68v-7.46c0-.47,0-.59.67-.59H1054c.64,0,.81,0,.81-.81V239.67c0-.68,0-.85.85-.85h31.81a48,48,0,0,1,6.87.76,41.25,41.25,0,0,1,13.28,4.92,37.65,37.65,0,0,1,7.47,5.77,41.06,41.06,0,0,1,4.54,5.64,34.2,34.2,0,0,1,3.31,6.49,1.09,1.09,0,0,0,1.27.89h7.59c1,0,1,0,1,.94v6.95c0,.68-.26.85-.94.85h-5.85c-.59,0-.76,0-.72.76a43.83,43.83,0,0,1,0,7.77c0,.72,0,.8.81.8h6.7c.29.38,0,.77,0,1.15a9.14,9.14,0,0,1,0,1.48v5.13c0,.73-.21.94-.85.94h-8a1.06,1.06,0,0,0-1.23.8,33.93,33.93,0,0,1-8.91,13,50,50,0,0,1-4.54,3.65c-1.69,1-3.35,2-5.08,2.8a45.83,45.83,0,0,1-10,3.18,52.3,52.3,0,0,1-9.92.81h-29.44v0Z" style="fill:#fefefd"/></g></g></g></svg>
        </div>


      </div>

      <div style="clear:both;display:block;text-align:right;min-height:50px;"></div>

    </div>
    
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {

    }
  },
  methods: {
    // menuClose: function () {
    //   this.$parent.menuOpen = false;
    // }
  },

  mounted() {
    // if (this.$route.name == 'ShoppingCart') {
    //   this.linkTo = '';
    //   this.linkText = '';
    // }

    // if (this.$route.name == 'CryptoLogo') {
    //   this.linkTo = '/'+this.$route.params.coinId;
    //   this.linkText = this.$parent.coins[this.$route.params.coinId].name+' ('+this.$parent.coins[this.$route.params.coinId].symbol+') Clothing';
    // }
    // else {
    //   this.linkTo = '';
    //   this.linkText = '';
    // }

    // else if (this.$route.name == 'CryptoClothing') {
    //   this.linkTo = this.homePath+'crypto-logos/'+this.$route.params.coinId;
    //   this.linkText = this.$route.params.coinId+' logo';
    // }
  },

  watch:{

  } 
}
</script>

<style>


.stick {
  color:#777;
}

.footer {
  width: 100%;
  /* border-top: 1px solid grey; */
  /* background: linear-gradient(to bottom, rgba(255,255,255,0.15) 0%, rgba(0,0,0,0.15) 100%), radial-gradient(at top center, rgba(255,255,255,0.40) 0%, rgba(0,0,0,0.40) 120%) #989898;  */
  /* background-blend-mode: multiply,multiply; */
  background-color:#333333;
  left: 0;
  /* padding-top: 15px;
  padding-bottom: 45px; */
  /* min-height: 50px; */
  /* position: absolute; */
  bottom: 0;
  width: 100%;
  overflow: hidden;
  /* height: 200px; */
}

@media only screen and (max-width: 480px) {
  .footer-content {
    padding-left: 15px;
    /* padding-right: 15px; */
  }
}

.footer-content {
  /* height: 300px; */
  max-width: 636px;
  /* max-width: 720px; */
  margin: 0 auto;
}

.footer-column {
  margin-top: 45px;
  width: 212px;
  float: left;
  line-height: 180%;
}

.footer {
  font-size: 14px;
  color: rgb(226, 226, 226);
  padding: 10px;
  box-sizing: border-box;
  padding-top: 0px;
}

.footer a {
  font-size: 14px;
  color: rgb(226, 226, 226)!important;
  line-height:22px;
  border-bottom: 0px!important;
}

.footer a:hover {
  text-decoration: underline!important;
  
  /* color:rgb(236, 236, 236)!important; */
}

  .footer-social {
    float:right;
  }

  /* @media screen and (max-width: 500px) {
    .footer-social {
      clear: both;
      float: left;
    }
  } */


</style>